var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4823 33.185C21.9994 33.185 21.508 33.3054 21.0566 33.5602L16.108 36.3603C14.7423 37.1331 14.2737 38.8439 15.0623 40.1852L17.9194 45.0321C18.448 45.9337 19.408 46.4349 20.3966 46.4349C20.8794 46.4349 21.3709 46.3117 21.8223 46.0597L26.7709 43.2596C28.1366 42.4868 28.6051 40.7732 27.8166 39.432L24.9594 34.5851C24.4309 33.6862 23.4709 33.185 22.4823 33.185ZM22.4851 35.9851L25.3423 40.832L20.3937 43.6321L17.5366 38.7851L22.4851 35.9851Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6306 54.7273L25.0591 57.1522L36.0734 50.9192L34.6449 48.4944L23.6306 54.7273Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8697 39.7201L54.4411 37.2952L65.6097 30.9755L67.0383 33.4003L55.8697 39.7201Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1211 47.0955L38.5497 49.5203L53.3954 41.1201L51.9669 38.6953L37.1211 47.0955Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5657 0.666504C55.5753 0.666504 54.5657 0.915236 53.647 1.43703L2.92783 30.1332C0.127722 31.7175 -0.832315 35.2295 0.787057 37.9763L18.3546 67.7972C19.9712 70.5413 23.5548 71.4822 26.3549 69.8952L77.0713 41.2017C79.8715 39.6147 80.8315 36.1054 79.2149 33.3613L61.6445 3.53774C60.5604 1.69658 58.5906 0.666504 56.5657 0.666504ZM4.35638 32.5581L55.0797 3.85962C55.5383 3.59915 56.0493 3.46657 56.5657 3.46657C57.6343 3.46657 58.6276 4.01637 59.1699 4.9373L76.7405 34.7613C77.5682 36.1662 77.0765 37.9642 75.641 38.7778L24.9265 67.4702C23.4917 68.2834 21.6566 67.8019 20.829 66.3972L3.26143 36.5763C2.43142 35.1684 2.92272 33.3693 4.35638 32.5581Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTender);
export default __webpack_public_path__ + "static/media/Tender.e3f4d6b94b4202c4e8d7c8ad4b45ca70.svg";
export { ForwardRef as ReactComponent };